import { render } from "./MapDetail.vue?vue&type=template&id=32b8e43c&scoped=true"
import script from "./MapDetail.vue?vue&type=script&lang=js"
export * from "./MapDetail.vue?vue&type=script&lang=js"

import "./MapDetail.vue?vue&type=style&index=0&id=32b8e43c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-32b8e43c"

export default script